import { FormHelperText, TextField } from "@mui/material"
import { Control, Controller, FieldValues, Path, useWatch } from "react-hook-form"
import css from "./LagLabelField.module.css"

type LabelFieldProps<TFieldValues extends FieldValues> = {
  control: Control<TFieldValues>
  name: Path<TFieldValues>
  additionalErrors?: string[]
  lag?: number
  lagValueFieldName?: Path<TFieldValues>
  label?: string
}

export const LagLabelField = <TFieldValues extends FieldValues>(
  props: LabelFieldProps<TFieldValues>,
) => {
  const label =
    useWatch({
      control: props.control,
      name: props.name,
    }) ?? ""

  const watchedLagValue = useWatch({
    control: props.control,
    name: props.lagValueFieldName ?? ("lagValue" as Path<TFieldValues>),
  })

  const lagValue = props.lag ?? watchedLagValue

  return (
    <>
      <Controller
        control={props.control}
        name={props.name}
        render={({ field, fieldState }) => (
          <>
            <TextField
              fullWidth
              inputProps={{
                style: {
                  fontSize: 20,
                  fontWeight: 700,
                  textAlign: "left",
                  width: label.length + 1 + "ch",
                },
              }}
              size="small"
              label={props.label ?? "Name"}
              helperText={fieldState.error?.message}
              error={Boolean(fieldState.error)}
              InputProps={{
                endAdornment: <span className={css.adornment}>{" Lag " + lagValue}</span>,
              }}
              InputLabelProps={{ shrink: true }}
              {...field}
            />
            {props.additionalErrors?.map((error, index) => (
              <FormHelperText key={`${error}-${index}`} error>
                - {error}
              </FormHelperText>
            ))}
          </>
        )}
      />
    </>
  )
}
